import React from "react";
import Detail from "./Detail";
import Logo from "./Logo";

function Content() {
  return (
    <div>
      <Logo />
      <Detail />
    </div>
  );
}

export default Content;
